import { APP_URL, LOGIN_URL } from "src/app/AppConstants";

export const redirectToLogin = (message?: string) => {
    if (!window.location.pathname.startsWith(LOGIN_URL)) {
        window.location.href = `${LOGIN_URL}/${message ?? ""}`;
    }
};

export const redirectToApp = () => {
    window.location.href = APP_URL;
};
